<script lang="ts">
  import { RepositoryNavProps } from "../models/props";


	let { activeTab = 'code', issueCount = 0, prCount = 0, onTabChange }: RepositoryNavProps = $props();

	const handleTabClick = (tab: string) => {
		if (onTabChange) {
			onTabChange(tab);
		}
	};

	const handleKeyPress = (event: KeyboardEvent, tab: string) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			handleTabClick(tab);
		}
	};
</script>

<!-- <nav class="mb-6 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm px-4"> -->
<nav class="mb-6 bg-white dark:bg-gray-800  ">
	<ul class="flex text-sm border-b border-gray-200 dark:border-gray-700">
		<li class="mr-2">
			<div
				role="button"
				tabindex="0"
				onclick={() => handleTabClick('code')}
				onkeydown={(e) => handleKeyPress(e, 'code')}
				class="group flex items-center px-4 py-3 font-medium cursor-pointer transition-all duration-200 border-b-2 {activeTab === 'code'
					? 'border-blue-500 text-blue-600 dark:text-blue-400'
					: 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'}"
			>
				<svg class="w-4 h-4 mr-2 transition-transform group-hover:scale-110" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
				Code
			</div>
		</li>
		<li class="mr-2">
			<div
				role="button"
				tabindex="0"
				onclick={() => handleTabClick('issues')}
				onkeydown={(e) => handleKeyPress(e, 'issues')}
				class="group flex items-center px-4 py-3 font-medium cursor-pointer transition-all duration-200 border-b-2 {activeTab === 'issues'
					? 'border-blue-500 text-blue-600 dark:text-blue-400'
					: 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'}"
			>
				<svg class="w-4 h-4 mr-2 transition-transform group-hover:scale-110" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
						clip-rule="evenodd"
					/>
				</svg>
				Issues
				{#if issueCount > 0}
					<span
						class="ml-2 px-2 py-0.5 text-xs font-semibold rounded-full {activeTab === 'issues'
							? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300'
							: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}"
					>
						{issueCount}
					</span>
				{/if}
			</div>
		</li>
		<li class="mr-2">
			<div
				role="button"
				tabindex="0"
				onclick={() => handleTabClick('pulls')}
				onkeydown={(e) => handleKeyPress(e, 'pulls')}
				class="group flex items-center px-4 py-3 font-medium cursor-pointer transition-all duration-200 border-b-2 {activeTab === 'pulls'
					? 'border-blue-500 text-blue-600 dark:text-blue-400'
					: 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'}"
			>
				<svg class="w-4 h-4 mr-2 transition-transform group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
					/>
				</svg>
				Pull Requests
				{#if prCount > 0}
					<span
						class="ml-2 px-2 py-0.5 text-xs font-semibold rounded-full {activeTab === 'pulls'
							? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300'
							: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}"
					>
						{prCount}
					</span>
				{/if}
			</div>
		</li>
		<li class="mr-2">
			<div
				role="button"
				tabindex="0"
				onclick={() => handleTabClick('security')}
				onkeydown={(e) => handleKeyPress(e, 'security')}
				class="group flex items-center px-4 py-3 font-medium cursor-pointer transition-all duration-200 border-b-2 {activeTab === 'security'
					? 'border-blue-500 text-blue-600 dark:text-blue-400'
					: 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'}"
			>
				<svg class="w-4 h-4 mr-2 transition-transform group-hover:scale-110" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
						clip-rule="evenodd"
					/>
				</svg>
				Security
			</div>
		</li>
		<li class="mr-2">
			<div
				role="button"
				tabindex="0"
				onclick={() => handleTabClick('settings')}
				onkeydown={(e) => handleKeyPress(e, 'settings')}
				class="group flex items-center px-4 py-3 font-medium cursor-pointer transition-all duration-200 border-b-2 {activeTab === 'settings'
					? 'border-blue-500 text-blue-600 dark:text-blue-400'
					: 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'}"
			>
				<svg class="w-4 h-4 mr-2 transition-transform group-hover:scale-110" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
						clip-rule="evenodd"
					/>
				</svg>
				Settings
			</div>
		</li>
	</ul>
</nav>
